import styled from "@emotion/styled";

export default styled.div`
	width: max-content;
	padding: 1.25em 1.5em;

	table {
		display: table;
	}
`;
